import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TaskOperationDto } from 'src/app/models/tasks/task-operation/task-operation-dto';

export interface GridInterface {
  columnName: string;
  i18n: string;
  translatable?: boolean;
}

@Component({
  selector: 'app-dialog-task-operation',
  templateUrl: './dialog-task-operation.component.html',
  styleUrls: ['./dialog-task-operation.component.scss']
})
export class DialogTaskOperationComponent implements OnInit {

  title: string;
  taskOperation: TaskOperationDto;
  propertiesToShow: string[] = ['user','activity','operationType', 'statusOperation', 'operationActionType','errorCode','executionDate','creationDate'];
  propertiesToShowSpecial: string[] = ['comment', 'description'];
  translatable: string[] = ['operationType', 'statusOperation', 'operationActionType'];

  propertiesToShowObj: GridInterface[];
  propertiesToShowSpecialObj: GridInterface[];

  constructor(public dialogRef: MatDialogRef<DialogTaskOperationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {title:string, taskOperation: TaskOperationDto}) {
  }

  ngOnInit() {
    this.title = this.data.title;
    this.taskOperation = this.data.taskOperation;
    this.propertiesToShowObj = this.setGrid(this.propertiesToShow);
    this.propertiesToShowSpecialObj = this.setGrid(this.propertiesToShowSpecial);
  }

  setGrid(propertiesObject: string[]){
    return propertiesObject.map(column => {
      let translatable = this.translatable.includes(column);

      return {
        columnName: column,
        i18n: 'ORDER_PROCESS_TABLE_KEY.',
        translatable: translatable,
      };
    });
  }

}
